module.exports = __webpack_public_path__ + "img/SCB.63f5300a.png";